import { INVESTIGATION_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';

export const CUSTOM_DETAILS_OPTIONS = {
    USER_PRINCIPAL_NAME: 'upn',
    DOMAIN: 'domain',
    MFA: 'mfa',
    SAM: 'sam',
    EMAIL: 'email',
    LAST_PASSWORD_CHANGE: 'lastPasswordChange',
    TENANT: 'tenant',
    APP_ID: 'appId',
    CREATED: 'created',
    UPDATED: 'updated',
    STATUS: 'status',
    OPERATING_SYSTEM: 'os',
    POLICIES: 'policies',
    SERVICES: 'services',
    LAST_LOGON: 'lastLogon',
    RISK_INDICATORS: 'riskIndicators',
    MEMBERSHIPS: 'memberships'
};

export const ENTITY_TYPE_TO_DETAILS_OPTIONS = {
    [INVESTIGATION_ENTITY_TYPES.USER.id]: [
        CUSTOM_DETAILS_OPTIONS.USER_PRINCIPAL_NAME,
        CUSTOM_DETAILS_OPTIONS.DOMAIN,
        CUSTOM_DETAILS_OPTIONS.MFA,
        CUSTOM_DETAILS_OPTIONS.SAM,
        CUSTOM_DETAILS_OPTIONS.EMAIL
    ],
    [INVESTIGATION_ENTITY_TYPES.APPLICATION.id]: [
        CUSTOM_DETAILS_OPTIONS.TENANT,
        CUSTOM_DETAILS_OPTIONS.APP_ID,
        CUSTOM_DETAILS_OPTIONS.CREATED
    ],
    [INVESTIGATION_ENTITY_TYPES.OKTA.id]: [
        CUSTOM_DETAILS_OPTIONS.APP_ID,
        CUSTOM_DETAILS_OPTIONS.UPDATED,
        CUSTOM_DETAILS_OPTIONS.STATUS
    ],
    [INVESTIGATION_ENTITY_TYPES.DEVICE.id]: [
        CUSTOM_DETAILS_OPTIONS.OPERATING_SYSTEM,
        CUSTOM_DETAILS_OPTIONS.DOMAIN,
        CUSTOM_DETAILS_OPTIONS.SERVICES,
        CUSTOM_DETAILS_OPTIONS.POLICIES,
        CUSTOM_DETAILS_OPTIONS.LAST_LOGON
    ],
    [INVESTIGATION_ENTITY_TYPES.RESOURCE.id]: [
        CUSTOM_DETAILS_OPTIONS.OPERATING_SYSTEM,
        CUSTOM_DETAILS_OPTIONS.DOMAIN,
        CUSTOM_DETAILS_OPTIONS.SERVICES,
        CUSTOM_DETAILS_OPTIONS.POLICIES,
        CUSTOM_DETAILS_OPTIONS.LAST_LOGON
    ]
};
